var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 136H16V376H496V136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 56H16V136H496V56Z",
    fill: "#2980B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V56H496V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 456H16V376H496V456Z",
    fill: "#2980B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H16V456H496V496Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.452 237.405L298.512 220.17H318.391L308.452 237.405V237.405ZM298.475 291.83L308.452 274.632L318.391 291.83H298.475ZM277.033 291.83H235.004L214.306 256.019L235.004 220.17H277.033L297.693 256.019L277.033 291.83ZM256 328.238L245.725 310.443H266.274L256 328.238ZM203.548 237.368L193.609 220.17H213.487L203.548 237.368ZM193.609 291.83L203.548 274.632L213.487 291.83H193.609ZM256 183.762L266.274 201.557H245.725L256 183.762V183.762ZM319.173 255.981L350.592 201.557H287.791L256 146.536L224.246 201.557H161.371L169.411 215.516L192.827 256.019L161.371 310.443H224.246L256 365.464L287.791 310.443H350.629L319.173 255.981",
    fill: "#2980B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/IL.22210c7bf9da3b6935d2ba442f618c9f.svg";
export { ForwardRef as ReactComponent };